export const dispositionTimer = (state: any) => {
  let ltime: any = state.callWrapupTime;
  
  //Reset timer
  // if(ltime===0){
  //   state.callWrapupTime=59
  //   ltime=59
  // }


  // let ss: any = ltime.split(":");
  // let dt = new Date();
  // let sa: any = [];
  // sa[0] = "00";
  // ss = sa.concat(ss);
  // dt.setMinutes(ss[1]);
  // dt.setSeconds(ss[2]);
  // let dt2 = new Date(dt.valueOf() + 1000);
  // let temp = dt2.toTimeString().split(" ");
  // let ts = temp[0].split(":");
  // let timer: any;
  // timer:any = ts[1] + ":" + ts[2];
  //
  // state.dispositionTime = timer;

  // let mins: number = parseInt(ss[0]);
  // let secs: number = parseInt(ss[1]);

  let dateObj = new Date(ltime * 1000);
  let hours = dateObj.getUTCHours();
  let minutes = dateObj.getUTCMinutes();
  let seconds = dateObj.getSeconds();
  let cycle = state.cycle;
  if (ltime === 0 || (cycle !== 0 && ltime === 60)) {
    // ltime = ltime + 60
    cycle = cycle + 1;
  }

  minutes = cycle;

  // if (state.cycle !== 0) {

  //   // if (ltime === 0) {
  //   //   // ltime = ltime + 60
  //   //   cycle = cycle + 1

  //   // }
  //   minutes = cycle;

  // }

  let timeString = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
  // if (mins === 0 && secs === 0) {
  //   secs = 59;
  //   // mins -= 1
  //   timer = `0${mins} : ${secs <= 9 ? `0${secs}` : secs}`;
  // } else if (mins !== 0 && secs === 0) {
  //   secs = 59;
  //   timer = `0${mins + 1} : ${secs <= 9 ? `0${secs}` : secs}`;
  // } else if (secs === 0) {
  //   // mins -= 1
  //   secs = 59;
  //   timer = `0${mins} : ${secs <= 9 ? `0${secs}` : secs}`;
  // } else {
  //   // secs -= 1
  //   timer = `0${mins} : ${secs <= 9 ? `0${secs - 1}` : secs - 1}`;
  // }

  ltime = cycle === 0 ? ltime - 1 : ltime + 1;

  state.dispositionTime = minutes.toString() === "0" ? timeString : `-${timeString}`;
  state.callWrapupTime = ltime === 60 ? 0 : ltime;
  state.cycle = cycle;
  state.started = true;
};
